import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { Redirect } from 'react-router'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import queryString from 'query-string'
import { pathOr, isEmpty, isNil } from 'ramda';
import { getEmail, getPassword } from '../../demo'
import { getValueLang } from '../../i18n'
import { apiUrl } from '../../config';
import { Store } from '../../context/store'
import { LoginStyled, FormStyled, LoginError } from './styled'
import Button from '../../components/inputs/Button'
import FormSelectLang from '../../components/inputs/FormSelectLang'
import Buttons from '../../modules/Buttons'
import Input from '../../components/inputs/FromInput'
import { useForm } from '../../hooks'
import Header from '../../modules/Header';

const LoginPage = () => {
  const history = useHistory();
  const location = useLocation();
  const { t, i18n } = useTranslation()
  const { state, actions } = Store()
  const [error, setError] = useState('')

  const validate = values => {
    const errors = {}
    if (!values.email) {
      errors.email = t("login_form.email_error_one")
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = t("login_form.email_error_two")
    }
    if (!values.pass) {
      errors.pass = t("login_form.password_error_one")
    }
    return errors
  }

  const login = async (formData) => {
    try {
      const res = await axios({
        method: 'POST',
        url: apiUrl + '/rpc/dologin',
        data: formData
      })
      const data = pathOr({}, ['data'], res)
      if (!isEmpty(data[0])) {
        //set default group
        actions.setSelectedGroup('')

        // set language
        if (process.env.REACT_APP_VERSION === 'DEMO') {
          changeLanguage(data[0].lang)
        } else {
          if (data[0].lang !== i18n.language) {
            await axios({
              method: 'POST',
              url: apiUrl + '/rpc/setuserlang',
              headers: {
                Authorization: `Bearer ${data[0].token}`
              },
              data: {
                lang: getValueLang(i18n.language)
              }
            })
          }
        }
        // manage version after login
        if (process.env.NODE_ENV === 'production') {
          if (data[0].vers === process.env.PUBLIC_URL) {
            actions.setLoginSuccess(data[0])
            history.push('/monitoring')
          } else if (!isNil(data[0].vers) && !isEmpty(data[0].vers)) {
            window.open(`${data[0].vers}/login?token=${data[0].token}&lang=${data[0].lang}&vers=${data[0].vers}`, '_self')
          } else {
            window.open(`${process.env.REACT_APP_BASE_PUBLIC_URL}/login?token=${data[0].token}&lang=${data[0].lang}&vers=${data[0].vers}`, '_self')
            // history.push(`${process.env.PUBLIC_URL}/login`)
          }
        } else if (process.env.NODE_ENV === 'development') {
          alert(`vers: ${data[0].vers}`)
          actions.setLoginSuccess(data[0])
          history.push('/monitoring')
        }
      } else {
        setError('Something went wrong, try again later.')
      }
    } catch (err) {
      let message = ""
      if (navigator.onLine) {
        message = pathOr('', ['response', 'data', 'message'], err)
      } else {
        message = t("login_form.offline_error")
      }
      setError(message)
    }
  }

  const loginDemo = lang => {
    const email = getEmail(lang)
    const pass = getPassword()
    login({ email, pass })
  }

  const changeLanguage = newLang => {
    const langFinded = i18n.languages.find(lang => lang === newLang.toLocaleLowerCase());
    if (langFinded !== undefined && langFinded !== i18n.language) {
      i18n.changeLanguage(langFinded)
    }
  }

  const { values, errors, handleChange, handleSubmit } = useForm({
    callback: login,
    validate: validate
  })

  const handleSubmitDemo = e => {
    e.preventDefault();
    loginDemo(i18n.language);
  }

  const handleChangeDemoOption = lang => {
    loginDemo(lang)
  }

  // manage version application before login
  useEffect(() => {
    if (process.env.REACT_APP_VERSION === 'DEMO') {
      // check lang from query
      if (location && location.search) {
        const values = queryString.parse(location.search)
        if (!isNil(values.lang) && !isEmpty(values.lang)) {
          changeLanguage(values.lang)
        }
      }
      // check lang from path as the second item
      else {
        const { pathname } = location
        const langPath = pathname.split('/')[2]
        if (langPath && langPath.length >= 2) {
          changeLanguage(langPath)
        }
      }
      history.push('/login')
    } else if (process.env.NODE_ENV === 'production') {
      // auto login
      if (location && location.search) {
        const values = queryString.parse(location.search)
        if (values.vers === process.env.PUBLIC_URL && (!isNil(values.token) && !isEmpty(values.token)) && (!isNil(values.lang) && !isEmpty(values.lang))) {
          changeLanguage(values.lang)
          actions.setLoginSuccess(values)
          history.push('/monitoring')
        }
      }
    } else if (process.env.NODE_ENV === 'development') {
      history.push('/login')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return state.user ? (
    <Redirect to="/" />
  ) : (
      <LoginStyled>
        <Header withLangSwitcher={process.env.REACT_APP_VERSION !== 'DEMO'} />
        {
          process.env.REACT_APP_VERSION !== 'DEMO' ?
            <FormStyled onSubmit={handleSubmit}>
              <Input
                placeholder={t('form_login')}
                name="email"
                onChange={handleChange}
                value={values.email}
                error={errors.email}
                fullWidth
                marginVertical
                autoComplete="username"
              />
              <Input
                placeholder={t('form_password')}
                type="password"
                name="pass"
                onChange={handleChange}
                value={values.pass}
                error={errors.pass}
                fullWidth
                marginVertical
                autoComplete="current-password"
              />
              {error &&
                <LoginError>
                  {error}
                </LoginError>
              }
              <Buttons>
                <Button
                  type="submit"
                  green
                  fullWidth
                  style={{ height: '45px' }}
                >
                  {t('login')}
                </Button>
              </Buttons>
            </FormStyled>
            :
            <FormStyled onSubmit={handleSubmitDemo} style={{ marginTop: '10px' }}>
              <Buttons>
                <Button
                  type="submit"
                  green
                  fullWidth
                  style={{ height: '45px' }}
                >
                  {t('demo_login')}
                </Button>
              </Buttons>
              <FormSelectLang
                onChange={handleChangeDemoOption}
              />
            </FormStyled>
        }
      </LoginStyled>
    )
}

export default LoginPage
